'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dictionary = require('./classes/Dictionary');

var _Dictionary2 = _interopRequireDefault(_Dictionary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _Dictionary2.default({
  EMPLOYED: 'I am employed by a registered broker/dealer, an exchange or FINRA',
  DIRECTOR_POLICYMAKER: 'I am a director or policymaker of a public company',
  SHAREHOLDER: 'I am a 10% shareholder of a public company',
  NONE: 'None of the above'
});